import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

function getStoredDrawerState() {
  try {
    const v = localStorage.getItem('drawer_open');
    if (v === 'open') return true;
    if (v === 'closed') return false;
  } catch {}
  return undefined;
}

const initialState = {
  // undefined means: let layout decide (by breakpoint) on first load
  isDashboardDrawerOpened: getStoredDrawerState() ?? false
};

const endpoints = {
  key: 'api/menu',
  master: 'master',
  dashboard: '/dashboard' // server URL
};

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerDrawerOpen(isDashboardDrawerOpened) {
  // to update local state based on key
  try {
    localStorage.setItem('drawer_open', isDashboardDrawerOpened ? 'open' : 'closed');
  } catch {}
  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false
  );
}
